import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import WebpartBase from '@webparts/views/WebpartBase'

@Component
export default class ShortCutWebpart extends WebpartBase {}
